import Vue from 'vue';
import Vuex from 'vuex';
// 模块
import user from './modules/user';
import common from './modules/common.js';


Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		user, // 用户中心
		common,

	}
});


export default new Vuex.Store({
	modules: {
		user, // 用户中心
		common,

	}
});